// Asset reference for running D0 prize giveaway
export const PRIZE_GIVE_AWAY_MODAL_IMAGE = "/images/steam-deck-full.webp";
